import { AuthRepositoryImpl } from '../Data/AuthRepositoryImpl';
import { CheckEmailUseCase } from '../Domain/usecases/CheckEmailUseCase';
import { SignInUseCase } from '../Domain/usecases/SignInUseCase';
import { SignUpUseCase } from '../Domain/usecases/SignUpUseCase';

const repository = new AuthRepositoryImpl();

export const authUseCases = {
  signIn: new SignInUseCase(repository),
  signUp: new SignUpUseCase(repository),
  checkEmail: new CheckEmailUseCase(repository),
};

